import { useMemo } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { useDossierStore } from "../../../store/dossierStore";
import { useMembreAccess } from "../../../hooks/useMembreAccess";
import {
  ParametresSidebar,
  type ParametresEntrepriseTab,
  type ParametresNavTab,
} from "../../../pages/Parametres/components/ParametresSidebar";

const ONGLETS: readonly ParametresEntrepriseTab[] = [
  "generaux",
  "exercice",
  "fiscaux",
  "liasse",
  "facturation",
  "tresorerie",
  "transmission",
  "regles",
  "journaux",
  "equipe",
];

function resolveActiveTab(pathname: string, ongletParam: string | null): ParametresEntrepriseTab | "plan_comptable" {
  if (pathname.startsWith("/parametres/plan-comptable")) return "plan_comptable";
  if (pathname === "/parametres/exercice") return "exercice";
  if (ongletParam && (ONGLETS as readonly string[]).includes(ongletParam)) {
    return ongletParam as ParametresEntrepriseTab;
  }
  return "generaux";
}

/** Navigation Paramètres (gradient) dans le panneau secondaire du Layout. */
export function ParametresOverlayNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { activeDossier } = useDossierStore();
  const { loading: membreAccessLoading, role } = useMembreAccess();

  const ongletParam = searchParams.get("onglet");
  const activeTab = useMemo(
    () => resolveActiveTab(location.pathname, ongletParam),
    [location.pathname, ongletParam]
  );

  const showJournauxTab =
    !(Boolean(activeDossier?.id) && membreAccessLoading) && (role === "owner" || role === null);

  const handleTabChange = (tab: ParametresNavTab) => {
    if (tab === "plan_comptable") {
      navigate("/parametres/plan-comptable");
      return;
    }
    navigate({ pathname: "/parametres/entreprise", search: `?onglet=${tab}` }, { replace: true });
  };

  if (!activeDossier) {
    return (
      <div className="flex h-full min-h-0 items-center justify-center px-4 py-6 text-center text-sm text-white/60">
        Sélectionnez un dossier pour accéder aux paramètres.
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 w-full flex-1 flex-col overflow-hidden">
      <ParametresSidebar
        activeTab={activeTab}
        onTabChange={handleTabChange}
        dossierNom={activeDossier.nom}
        showJournauxTab={showJournauxTab}
      />
    </div>
  );
}
